var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"App"}},[(_vm.isRouterAlive)?_c('Announcement'):_vm._e(),(_vm.isRouterAlive)?_c('Header'):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.isRouterAlive)?_c('Footer'):_vm._e(),_c('div',{staticClass:"overlay"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }